<template>
  <RevButton
    :class="$style.applePayButton"
    data-test-styled-apple-pay
    variant="primary"
  />
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'
</script>

<style module>
.applePayButton {
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: buy;
  -apple-pay-button-style: black;
  height: 52px;
}
</style>
